import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

// services
import { ProfileService } from '@app/profile/services/profile.service';
import { TranslateService } from '@ngx-translate/core';
import { TrackerService } from '@dg/shared-services';

// types
import { Profile, Options } from '@app/profile/profile';

@Component({
  selector: 'dgx-user-info-bio-modal',
  templateUrl: './user-info-bio-modal.component.html',
  styleUrls: ['./user-info-bio-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserInfoBioModal implements OnInit {
  @Input() public bio: string = '';
  @Input() public options: Pick<Options, 'privacyId'>;
  @Input() public profile: Profile;
  @Input() public isActiveLearner: boolean;

  public i18n = this.translateService.instant(['Core_Add']);
  public headerText: string;

  constructor(
    private profileService: ProfileService,
    private translateService: TranslateService,
    private trackerService: TrackerService
  ) {}

  public ngOnInit(): void {
    this.headerText = this.translateService.instant(
      'UserInfoPartial_BioModalTitle',
      { name: this.profile.name }
    );
    this.trackBioModalOpen();
  }

  private trackBioModalOpen(): void {
    const privacyOptions = { 0: 'Public', 1: 'OrgVisible', 2: 'Private' };
    const visibility = privacyOptions[this.options.privacyId];

    this.trackerService.trackEventData({
      action: 'Profile Banner Clicked',
      properties: {
        ProfileType: this.profileService.getProfileType(),
        ProfileVisibility: visibility,
        ProfileBannerText: this.bio,
        IsActiveLearner: this.isActiveLearner,
      },
    });
  }
}
